import axios from "axios";
import i18n from "@/i18n";
const config = require('@/config')
const maps= {
    state: () => ({
        restId: '',
        restDeliveryZones: [],
        mapsLoading: false,
        restCity: '',
    }),
    getters: {
        REST_ID(state) {return state.restId},
        REST_DELIVERY_ZONES(state) {return state.restDeliveryZones},
        MAPS_LOADING(state) {return state.mapsLoading},
        REST_CITY(state) {return state.restCity},
    },
    mutations: {
        setRestDeliveryZones(state, zones) {
            state.restDeliveryZones = zones
        },
        setRestCity(state, city) {
            state.restCity = city
        },
        setRestId(state, id) {
            state.restId = id
            this.dispatch('searchRestDeliveryZones')
        },
    },
    actions: {
        searchRestDeliveryZones({ state, commit, dispatch, rootState }) {
            let id = state.restId
            let rests = rootState.restaurants
            for (let key in rests) {
                if(id === rests[key].id) {
                    commit('setRestDeliveryZones', rests[key].delivery_zones)
                    commit('setRestCity', rests[key].address_settings.city)
                    break
                }
            }
        },
        async putRestaurantMaps({ state, commit, dispatch, rootState }, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            state.mapsLoading = true
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.put(`${config.servUrl}admin/restaurants/` + payload.restId, payload.data, axiosHeader)
                .then(response => {
                    dispatch('addNewNotice', {text: i18n.global.t('deliveryZones.alerts.mapUpdated')})
                    return true
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                    return false
                })
                .finally(() => (state.mapsLoading = false))
        },
    }
}
export {maps}
